angular.module('EdxDistrictReportModule', []);